// tslint:disable:no-empty-interface
import { Observable } from 'rxjs';

export abstract class DataSourceHttpService {
	abstract getConfig<T = any>(criteria: IDataSourceGetConfigByTypeCriteria): Observable<IDataSourceGetConfigResult<T>>;
	abstract getConfig<T = any>(
		criteria: IDataSourceGetConfigByEntityCriteria
	): Observable<IDataSourceGetConfigResult<T>>;

	abstract getData<T = any>(criteria: IDataSourceGetDataByTypeCriteria): Observable<IDataSourceGetDataResult<T>>;
	abstract getData<T = any>(criteria: IDataSourceGetDataByEntityTypeCriteria): Observable<IDataSourceGetDataResult<T>>;
}

export interface IDataSourceGetDataByEntityTypeCriteria {
	id: number;
	type: DataSourceEntityType;
	request: any;
}

export interface IDataSourceGetDataByTypeCriteria {
	type: DataSourceType;
	request: any;
}

export interface IDataSourceGetDataResult<T = any> {
	data: T[];
	total: number;
	group?: any[];
	aggregates?: any;
}

export interface IDataSourceGetConfigByTypeCriteria {
	type: DataSourceType;
	isAdmin?: boolean;
}

export interface IDataSourceGetConfigByEntityCriteria {
	type: DataSourceEntityType;
	id: number;
	isAdmin?: boolean;
}

export interface IDataSourceGetConfigResult<T = any> {
	id: number;
	type: string;
	settings: Array<T>;
	smartFilters?: ISmartFilter[];
}

export interface ISmartFilter {
	id: number;
	name: string;
}

export enum DataSourceType {
	default = 'default',
	general = 'general',
	signatures = 'signatures',
}

export enum DataSourceEntityType {
	subcategory = 'subcategory',
}
